import { accommodationSubTypeIdZodSchema } from "@@/shared/acquire/resources/resource-accommodation/accommodation-types/accommodation-sub-type-id";
import { accommodationTypeIdZodSchema } from "@@/shared/acquire/resources/resource-accommodation/accommodation-types/accommodation-type-id";
import { pickedPickedAccommodationSubTypeZodObject } from "@@/shared/acquire/resources/resource-accommodation/accommodation-types/picked-accommodation-sub-type";
import { iconNameZodString } from "@@/shared/icon-name";
import {
    requiredTranslatableZodSchema,
    translatableZodSchema,
} from "@@/shared/translations/translation";
import { z } from "zod";

const pickedPickedAccommodationTypeZodObject = z.object({
    _type: z.literal("PICKED_ACCOMMODATION_TYPE"),

    typeId: accommodationTypeIdZodSchema,
    title: requiredTranslatableZodSchema,
    iconName: iconNameZodString.optional(),
    shortDescription: translatableZodSchema.optional(),
    subType: pickedPickedAccommodationSubTypeZodObject.optional(),
    subTypes: z.record(accommodationSubTypeIdZodSchema, z.number()).optional(),
});

type PickedAccommodationType = z.infer<
    typeof pickedPickedAccommodationTypeZodObject
>;

const pickedAccommodationTypeFactoryParamsZodObject =
    pickedPickedAccommodationTypeZodObject.omit({
        _type: true,
    });

type FactoryParams = z.infer<
    typeof pickedAccommodationTypeFactoryParamsZodObject
>;
const pickedAccommodationTypeFactory = (
    params: FactoryParams,
): PickedAccommodationType => {
    return {
        ...params,
        _type: "PICKED_ACCOMMODATION_TYPE",
    };
};

export {
    pickedAccommodationTypeFactory,
    pickedAccommodationTypeFactoryParamsZodObject,
    pickedPickedAccommodationTypeZodObject,
};
export type {
    PickedAccommodationType,
    FactoryParams as PickedAccommodationTypeFactoryParams,
};
